import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth';

export type SucessData = {
  token: string;
};

export type ErrorData = {
  error: string;
};

export type StoreStateData = SucessData &
  ErrorData & {
    status: 'completed' | 'pending' | 'uninitiated';
  };

const store = configureStore({
  reducer: { auth: authReducer },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
